import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const BusinessGridItem = ({ index, items, item, itemName, setCategories }) => {
  return (
    <div className="business-grid__item">
      <input
        type="checkbox"
        id={`business-type-checkbox-${index}`}
        className="visually-hidden"
        name={itemName}
        checked={item.selected}
        onChange={() => {}}
        onClick={() => {
          setCategories(item, items);
        }}
      />
      <label
        htmlFor={`business-type-checkbox-${index}`}
        className={`business-grid__content${item.selected ? ' selected' : ''}`}
      >
        <img src={item.url}
          alt={item.text}
          className="business-grid__image"
        />
        <div className="business-grid__text">{item.text}</div>
      </label>
    </div>
  );
};

BusinessGridItem.propTypes = {
  index: PropTypes.number,
  items: PropTypes.object,
  item: PropTypes.object,
  itemName: PropTypes.string,
  setCategories: PropTypes.func,
};

export default BusinessGridItem;
